// @ts-ignore: Подавление ошибки с модулем three.js
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Canvas } from '@react-three/fiber';
import { OrbitControls } from '@react-three/drei';
// @ts-ignore: Подавление ошибки с модулем three.js
import * as THREE from 'three';
import { useTheme } from '../contexts/ThemeProvider';
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader';
import { useTranslation } from 'react-i18next';

const ModelScreenshot: React.FC = () => {
  const { fileId } = useParams<{ fileId: string }>();
  const [model, setModel] = useState<THREE.Group | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const { t } = useTranslation();
  const { isDark } = useTheme();
  
  // Загрузка модели
  useEffect(() => {
    if (!fileId) {
      setError('Идентификатор файла не указан');
      setLoading(false);
      return;
    }
    
    console.log('ModelScreenshot: Загрузка модели с ID', fileId);
    
    const loader = new FBXLoader();
    loader.load(
      `/api/get-model?fileId=${fileId}`,
      (loadedModel: THREE.Group) => {
        console.log('ModelScreenshot: Модель успешно загружена');
        setModel(loadedModel);
        setLoading(false);
      },
      (xhr: { loaded: number; total: number }) => {
        console.log(`ModelScreenshot: Прогресс загрузки ${Math.round((xhr.loaded / xhr.total) * 100)}%`);
      },
      (error: Error) => {
        console.error('ModelScreenshot: Ошибка при загрузке модели', error);
        setError('Ошибка при загрузке модели');
        setLoading(false);
      }
    );
    
    return () => {
      // Очистка ресурсов при размонтировании
      if (model) {
        console.log('ModelScreenshot: Очистка ресурсов модели');
        model.traverse((child: THREE.Object3D) => {
          if (child instanceof THREE.Mesh) {
            if (child.geometry) child.geometry.dispose();
            if (child.material) {
              if (Array.isArray(child.material)) {
                child.material.forEach((mat: THREE.Material) => mat.dispose());
              } else {
                child.material.dispose();
              }
            }
          }
        });
      }
    };
  }, [fileId, model]);

  return (
    <div className="w-full h-screen">
      {loading ? (
        <div className="w-full h-full flex items-center justify-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
          <p className="ml-3">{t('loading')}</p>
        </div>
      ) : error ? (
        <div className="w-full h-full flex items-center justify-center">
          <p className="text-destructive">{error}</p>
        </div>
      ) : (
        <Canvas 
          camera={{ position: [0, 1.2, 4], fov: 35 }}
          style={{ 
            width: '100%', 
            height: '100%',
            background: isDark ? '#1a1a1a' : '#f5f5f5'
          }}
        >
          <ambientLight intensity={0.5} />
          <directionalLight position={[10, 10, 5]} intensity={1} />
          <directionalLight position={[-10, 10, 5]} intensity={0.5} />
          <OrbitControls enableZoom={false} autoRotate autoRotateSpeed={1} />
          {model && <primitive object={model} />}
        </Canvas>
      )}
    </div>
  );
};

export default ModelScreenshot; 